import React from "react";
import PagesTop from "../../components/Frontend/PagesTop";
import HomePageLayout from "../../layouts/HomepageLayout";
import aboutBg from "../../styles/bgs/asset 26.png";

const About = () => {
  return (
    <HomePageLayout>
      <div className="about">
        <PagesTop title="Who We Are" link="About Us" bg={aboutBg} />
        <div className="about-body">
          <div className="about-wrapper">
            <section className="about-ic">
              {/* <p>Learn About Us</p> */}
              <h2 className="fw-bold">About Kuxtech</h2>

              <p>
                Kuxtech is a fund company based in the United States of America
                that sees into the future in the tech industry and primarily aim
                at providing our customers financial assets across diverse
                leading prospects booming in the financial markets of the
                technology industry. Kuxtech is a vision driven financial tech
                company incorporated on the 13th of October 2004 growing with
                satisfied customers throughout the years. We are registered
                under the Securities Act of 1933 and the Investment Company Act
                of 1940, The Internet Corporation for Assigned Names and Numbers
                ICANN, and regulated by the Securities and Exchange Commission
                (SEC) under the Investment Company Act of 1940.
              </p>
              {/* <p>
                        All our employees have careers in large corporations dealing with the multiplication of clients' money. Based on their professional experience, they invest using all available forms such as investing in gold, currencies, oil, real estate, listed companies and the most popular and profitable field of Cryptocurrency, start-ups and ICOs. All of the above factors influence our generation of profits up to 20% in 1 day.
                    </p> */}
            </section>
            <section className="what-we-do">
              <h3 className="fw-bold">What we do</h3>
              <p>
                Kuxtech makes it easy to build your financial future with
                convenient online savings and investing tools, and financial
                advice at your fingertips.
              </p>
              <ul>
                <li>
                  <strong>Effortlessly invest</strong> for your future with a
                  professionally-managed portfolio that’s matched to your goals.
                </li>
                <li>
                  <strong>Put your savings to work</strong> at the touch of a
                  button with high-interest savings.
                </li>
                <li>
                  <strong>Get answers to your money questions anytime</strong>,
                  anywhere, so you can make smart moves.
                </li>
                <li>
                  <strong>Build a brighter future</strong> with financial advice
                  and retirement planning included in your already low fee.
                </li>
              </ul>
            </section>
            {/* <section>
            <div className="section-title">
              <h3>Members Experience</h3>
              <p>What Our Clients Say About Us.</p>
            </div>
            <Testimonials />
          </section> */}
          </div>
        </div>
      </div>
    </HomePageLayout>
  );
};

export default About;
